module.exports = "<v-container fill-height pa-0>\n  <v-flex xs4 text-xs-left>\n    <v-subheader>\n      <strong class=\"text-lg-right\" :class=\"isRequired ? 'label-required--has-required':'label-required--norequired'\">{{$t(label)}}</strong>\n    </v-subheader>\n  </v-flex>\n  <v-flex xs7>\n    <slot></slot>\n  </v-flex>\n</v-container>";


//////////////////
// WEBPACK FOOTER
// ./src/containers/ticket/components/ticket-modal-group-control/template.html
// module id = 9/Bh
// module chunks = 0